import { SelectionModel } from "@angular/cdk/collections";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatMenuTrigger } from "@angular/material/menu";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ReplaySubject, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Router } from "@angular/router";
import { BaseRequestService } from "app/_services/base.service";
import { AuthenticationService } from "app/_services/authentication.service";
import { LoaderService } from "../../_services/loader.service";
import { FormControl } from "@angular/forms";
import { MyToastrService } from "../../_services/toastr.service";
import { MatTableDataSource } from "@angular/material/table";
import { CommonService } from "../../_services/common.services";
import { MatDrawer } from "@angular/material/sidenav";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { cloneDeep } from "lodash";

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: "app-s-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }],
})
export class TableComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  innerHeight: any;
  sortOptions: any;
  selectedDateRange: { startDate: Date | null; endDate: Date | null } = {
    startDate: null,
    endDate: null,
  };
  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;
  selectedChangeEndDate: Date | null = null;
  dateRanges: Array<{ startDate: Date | null; endDate: Date | null }> = [];
  public assetDrpCtrl: FormControl = new FormControl();
  public displayedColumns!: Array<any>;
  public showhideList!: Array<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild("filterMenuTrigger", { static: false })
  filterMenuTrigger!: MatMenuTrigger;
  @ViewChild("listMenuTrigger", { static: false })
  listMenuTrigger!: MatMenuTrigger;
  @ViewChild("exportMenuTrigger", { static: false })
  exportMenuTrigger!: MatMenuTrigger;
  @ViewChild(MatSort, { static: false })
  set sort(value: MatSort) {
    // this.dataSource.sort = value;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild("drawer") drawer: MatDrawer;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  drawerMode: "over" | "side" = "over";
  // eslint-disable-next-line @typescript-eslint/member-ordering
  drawerOpened: boolean = false;
  filterText!: string;
  currentPageIndex: any;
  isExport = false;
  tableId: any;
  // @ts-ignore

  // tslint:disable-next-line:variable-name
  _sTableOptions: any;
  isLoading = true;
  dataSource = new MatTableDataSource<any>();
  hiddenDataSource = new MatTableDataSource<any>();

  @ViewChild("MAINTABLEDIV", { static: false })
  tableDiv!: ElementRef;

  @Input() sTableOptions: any;
  @Input() hideDownload: any;
  @Output() filterCallback = new EventEmitter();
  @Output() colFilterCallback = new EventEmitter();
  @Output() colListFilterCallback = new EventEmitter();
  @Output() publishCallback = new EventEmitter();
  @Output() sortCallback = new EventEmitter();
  @Output() actionCallback = new EventEmitter();
  @Output() globalActionCallback = new EventEmitter();
  @Output() pageCallback = new EventEmitter();
  @Output() refreshCallback = new EventEmitter();
  @Output() hyperlinkCallback = new EventEmitter();
  @Output() addCallback = new EventEmitter();
  @Output() compareCallback = new EventEmitter();
  @Output() timerCallback = new EventEmitter();
  @Output() checkBoxCallback = new EventEmitter();
  @Output() selectionchangeCallback = new EventEmitter();
  @Output() parentCallback = new EventEmitter();
  @Output() totalCallback = new EventEmitter();
  @Output() apiDataDownload = new EventEmitter();
  colFilters: any = [];
  filterValues!: string;
  filterArray: any = [];
  selectedTimer = "0";
  intervalId: any;
  called = false;
  cFilter: any;
  public touchUi = false;
  public enableMeridian = true;
  public minDate: moment.Moment;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  colHash: any = {};
  cFields: any = [];
  colFilterQuery: any;
  filterQuery: any;
  private tmpOption: any;
  columnsList: string[] = [];
  cpIndex = 0;
  tableOptions: any = {
    id: "imaws",
    title: "",
    report: "",
    downloadKey: "",
    isServerSide: true,
    selectText: "item(s)",
    floatingFilter: true,
    rowSelection: true,
    loading: true,
    downloadMax: 0,
    diffDate: 0,
    showAction: false,
    report_type: "",
    actionMenuItems: [
      {
        text: "Details",
        icon: "info",
        callback: "editFunction",
        hideLocal: false,
        isGlobal: false,
      },
    ],
    isActionCondition: false,
    actionConditons: { key: "" },
    actionConditionsList: {},
    pagination: true,
    pageOptions: [5, 10, 20, 30, 50, 100, 200],
    pageSize: 5,
    pageTotal: 0,
    search: false,
    showhideList: true,
    refreshData: true,
    dropdwn: false,
    add: false,
    showColFilter: false,
    exportExcel: true,
    compareData: false,
    publish: false,
    parentCalls: [],
    saveData: false,
    nomsg: "",
    filterDownload: true,
  };

  isMUltiple = true;
  initSelectedValues = [];
  selection = new SelectionModel<any>(this.isMUltiple, this.initSelectedValues);
  numSelected!: number;

  isCompMUltiple = true;
  initCompSelectedValues = [];
  compSelection = new SelectionModel<any>(
    this.isMUltiple,
    this.initCompSelectedValues
  );
  compNumSelected!: number;

  orderlist!: Array<any>;

  filterUpdate = new Subject<string>();
  colfilterUpdate = new Subject<any>();
  settingsObj = [];
  sessionData: any;
  searchedColName = "";
  colfilter: any = {};
  pastIndex: any;
  isPageLoad = true;

  isActionChanged = false;
  isTablePadding = false;
  columnsCnt = 0;
  exportCnt = 0;
  isExportClick = false;

  hasSelect = false;
  excelDownload: any = "";
  constructor(
    private activeRoute: Router,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    public baseService: BaseRequestService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private eRef: ElementRef,
    public toast: MyToastrService,
    public cdr: ChangeDetectorRef,
  ) {
    iconRegistry.addSvgIconLiteral(
      "excelDownload",
      // eslint-disable-next-line max-len
      sanitizer.bypassSecurityTrustHtml(
        '<svg viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><defs><style>.prefix__cls-1{fill:#354463}</style></defs><g id="prefix__excel" transform="translate(0 -16.01)"><g id="prefix__Group_699" data-name="Group 699" transform="translate(0 16.01)"><g id="prefix__Group_698" data-name="Group 698"><path id="prefix__Path_1049" d="M12.131 16.193a.623.623 0 0 0-.565-.17l-11 2.4a.775.775 0 0 0-.566.786v17.6a.777.777 0 0 0 .561.786l11 2.4a.569.569 0 0 0 .127.014.632.632 0 0 0 .439-.184.858.858 0 0 0 .249-.616v-22.4a.855.855 0 0 0-.245-.616zM11 38.245l-9.629-2.1V19.873L11 17.774z" class="prefix__cls-1" data-name="Path 1049" transform="translate(0 -16.01)"/></g></g><g id="prefix__Group_701" data-name="Group 701" transform="translate(12.996 18.76)"><g id="prefix__Group_700" data-name="Group 700"><path id="prefix__Path_1050" d="M266.316 79.99h-9.629a.858.858 0 0 0 0 1.682h8.941v15.135h-8.941a.858.858 0 0 0 0 1.682h9.629a.776.776 0 0 0 .688-.841V80.831a.776.776 0 0 0-.688-.841z" class="prefix__cls-1" data-name="Path 1050" transform="translate(-256 -79.99)"/></g></g><g id="prefix__Group_705" data-name="Group 705" transform="translate(12.23 21.884)"><g id="prefix__Group_704" data-name="Group 704"><path id="prefix__Path_1052" d="M259.439 207.99h-2.751a.688.688 0 1 0 0 1.376h2.751a.688.688 0 0 0 0-1.376z" class="prefix__cls-1" data-name="Path 1052" transform="translate(-256 -207.99)"/></g></g><g id="prefix__Group_707" data-name="Group 707" transform="translate(12.23 26.584)"><g id="prefix__Group_706" data-name="Group 706"><path id="prefix__Path_1053" d="M259.439 271.99h-2.751a.688.688 0 1 0 0 1.376h2.751a.688.688 0 0 0 0-1.376z" class="prefix__cls-1" data-name="Path 1053" transform="translate(-256 -271.99)"/></g></g><g id="prefix__Group_709" data-name="Group 709" transform="translate(12.23 31.284)"><g id="prefix__Group_708" data-name="Group 708"><path id="prefix__Path_1054" d="M259.439 335.99h-2.751a.688.688 0 1 0 0 1.376h2.751a.688.688 0 0 0 0-1.376z" class="prefix__cls-1" data-name="Path 1054" transform="translate(-256 -335.99)"/></g></g><g id="prefix__Group_713" data-name="Group 713" transform="translate(18.498 21.884)"><g id="prefix__Group_712" data-name="Group 712"><path id="prefix__Path_1056" d="M386.063 207.99h-1.375a.688.688 0 1 0 0 1.376h1.375a.688.688 0 1 0 0-1.376z" class="prefix__cls-1" data-name="Path 1056" transform="translate(-384 -207.99)"/></g></g><g id="prefix__Group_715" data-name="Group 715" transform="translate(18.498 26.584)"><g id="prefix__Group_714" data-name="Group 714"><path id="prefix__Path_1057" d="M386.063 271.99h-1.375a.688.688 0 1 0 0 1.376h1.375a.688.688 0 1 0 0-1.376z" class="prefix__cls-1" data-name="Path 1057" transform="translate(-384 -271.99)"/></g></g><g id="prefix__Group_717" data-name="Group 717" transform="translate(18.498 31.284)"><g id="prefix__Group_716" data-name="Group 716"><path id="prefix__Path_1058" d="M386.063 335.99h-1.375a.688.688 0 1 0 0 1.376h1.375a.688.688 0 1 0 0-1.376z" class="prefix__cls-1" data-name="Path 1058" transform="translate(-384 -335.99)"/></g></g><g id="prefix__Group_719" data-name="Group 719" transform="translate(3.872 24.57)"><g id="prefix__Group_718" data-name="Group 718"><path id="prefix__Path_1059" d="M86.025 181.721l-4.814-5.5a.688.688 0 0 0-1.036.905l4.814 5.5a.688.688 0 0 0 1.036-.905z" class="prefix__cls-1" data-name="Path 1059" transform="translate(-80.004 -175.984)"/></g></g><g id="prefix__Group_721" data-name="Group 721" transform="translate(3.872 23.794)"><g id="prefix__Group_720" data-name="Group 720"><path id="prefix__Path_1060" d="M85.924 160.138a.688.688 0 0 0-.966.12l-4.814 6.19a.688.688 0 0 0 1.085.846l4.814-6.19a.687.687 0 0 0-.119-.966z" class="prefix__cls-1" data-name="Path 1060" transform="translate(-79.999 -159.992)"/></g></g></g></svg>'
      )
    );
    this.innerHeight = "384px";
    this.loaderService.selectedSiteChanged.subscribe(() => {
      localStorage.removeItem(this.tableOptions.id);
      this.filterText = "";
    });
    this.loaderService.tableProgressOff.subscribe(() => {
      this.tableOptions.loading = false;
    });
    // Debounce search.
    this.filterUpdate
      .pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe((value) => {
        this.isActionChanged = true;
        this.doFilter(value);
      });

    this.colfilterUpdate
      .pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe((value) => {
        this.doColumFilter(value.value, value.col);
      });
  }
  @HostListener("document:click", ["$event"])
  clickout(event: any): void {
    if (this.eRef.nativeElement.contains(event.target)) {
      if (this.isExportClick) {
        if (this.exportCnt > 1) {
          if (this.exportMenuTrigger !== undefined) {
            this.exportMenuTrigger.closeMenu();
          }
          this.exportCnt = 1;
          this.isExportClick = false;
        } else {
          if (this.listMenuTrigger !== undefined) {
            this.listMenuTrigger.closeMenu();
          }
          this.exportCnt++;
        }
      } else {
        if (this.columnsCnt > 1) {
          if (this.listMenuTrigger !== undefined) {
            this.listMenuTrigger.closeMenu();
          }
          this.columnsCnt = 1;
        } else {
          if (this.exportMenuTrigger !== undefined) {
            this.exportMenuTrigger.closeMenu();
          }
          this.columnsCnt++;
        }
      }
    } else {
      this.columnsCnt = 0;
      if (this.listMenuTrigger !== undefined) {
        this.listMenuTrigger.closeMenu();
      }
    }
  }

  columnFilterxlsx(col?: any): void {
    // this.colFilters = [];
    if (!col) {
      this.colFilterCallback.emit({});
      return;
    }
    console.log('col', col);
    this.searchedColName = col.col;
    if (col.dateCol && col.dateCol.start && col.dateCol.end) {
      this.colFilters.push({
        key: col.searchstring,
        name: col.header,
        value: `form ${col.dateCol.start} - to ${col.dateCol.end} `,
        hKey: col.colFilters.hKey,
        list: col?.list,
        dateCol: col.dateCol,
        type: col.type
      });
    } else {
      this.colFilters.push({
        key: col.searchstring,
        name: col.header,
        value: col.val,
        hKey: col.colFilters.hKey,
        dateCol: col.dateCol,
        type: col.type
      });
    }
    this.colFilters.forEach(item => {
      if (item.type === 'float') {
        item.value = Number(item.value)
      }
    });
    this.processColFilterQuery();
  }

  removeFilterxlsx(rFilter: any): void {
    if (this.sTableOptions.gFilter) {
      delete this.sTableOptions.gFilter;
      this.colFilters = [];
      this.colFilterQuery = [];
      this.filterQuery = {};
      this.getCollectionData();
      return;
    }
    this.colFilters.forEach((obj: { key: string | number }, index: any) => {
      if (rFilter.key === obj.key) {
        this.colfilter[obj.key] = "";
        this.colFilters.splice(index, 1);
      }
    });
    this.processColFilterQuery();
  }
  processColFilterQuery(): void {
    this.colFilterQuery = [];
    const query: any = {};
    for (const cl of this.colFilters) {
      if (cl.dateCol && cl.dateCol.start && cl.dateCol.end) {
        // @ts-ignore
        query[cl.key] = {
          $gte: new Date(cl.dateCol.start).getTime(),
          $lte: new Date(cl.dateCol.end).getTime(),
        };
      } else {
        // @ts-ignore
        query[cl.key] = cl.value;
      }
    }
    this.colFilterCallback.emit(query);
  }
  processColFilterQueryOld(): void {
    this.colFilterQuery = [];
    for (const cl of this.colFilters) {
      const tmpObj1: any = { bool: { should: [{ match: {} }] } };
      let tmpObj: any = {};
      if (cl.hKey) {
        tmpObj = {
          bool: {
            should: [
              { query_string: { fields: [cl.key], query: `*${cl.value}*` } },
            ],
          },
        };
      } else {
        tmpObj1.bool.should[0].match[cl.key] = cl.value;
        tmpObj = tmpObj1;
      }
      this.colFilterQuery.push(tmpObj);
    }
    this.getCollectionData();
  }

  apiDownload(type: any): void {
    const dateStr =
      new Date().toLocaleDateString().replace(/\//g, "_") +
      "_" +
      new Date().toLocaleTimeString().replace(/\:/g, "_");
    this.baseService
      .doRequest(`/download/ProductMaster.csv`, "post", {})
      .subscribe(
        (result: any) => {
          this.loaderService.display(false);
          window.open(
            "http://127.0.0.1:5000/download/ProductMaster.csv",
            "_blank"
          );
        },
        (error: any) => {
          this.loaderService.display(false);
          window.open(
            "http://127.0.0.1:5000/download/ProductMaster.csv",
            "_blank"
          );
        }
      );
  }
  onStartDateChange(event: any): void {
    this.selectedStartDate = event.value || null;
    console.log('Start Date Selected:', this.selectedStartDate);
  }
  onEndDateChange(event: any): void {
    if (event.value) {
      const date = new Date(event.value);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        console.error('Invalid date');
        this.selectedEndDate = null;
      } else {
        this.selectedEndDate = date;
        const datevale = cloneDeep(date)
        datevale.setDate(date.getDate() + 1);
        this.selectedChangeEndDate = datevale;
      }
    } else {
      this.selectedEndDate = null;
    }

    // Emit the updated dates only if both start and end dates are selected
    if (this.selectedStartDate && this.selectedChangeEndDate) {
      this.commonService.onTransDataChange.next({
        startDate: this.selectedStartDate,
        endDate: this.selectedChangeEndDate,
      });
    }
  }

  clearDateRange(): void {
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedChangeEndDate = null;
    this.commonService.onTransDataChange.next({ startDate: null, endDate: null });
    console.log('Date range cleared');
  }
  downloadAsXls(type: string): void {
    this.apiDataDownload.emit({});
    return;
    this.loaderService.display(true, "Preparing download....");

    const params: any = {};
    params.collection = this.tableOptions.collection;
    params.query = Object.assign(this.sTableOptions._query.query);
    params.query.limit = 0;
    if (this.sTableOptions.tableOptions.downloadKey) {
      params.type = this.sTableOptions.tableOptions.downloadKey;
    }
    if (this.sTableOptions.tableOptions.report) {
      params.report_name = this.sTableOptions.tableOptions.report;
    }
    if (this.sTableOptions.tableOptions.report_type) {
      params.report_type = this.sTableOptions.tableOptions.report_type;
    }
    /* params.query =  { limit: 0, fields: []};
        params.query.fields = [];
        this.sTableOptions.columns.forEach((obj) => {
            if (obj.visible) { params.query.fields.push(obj.columnDef); }
        });
        console.log(this.sTableOptions._query); */
    if (
      this.tableOptions.downloadMax &&
      this.tableOptions.diffDate > this.tableOptions.downloadMax
    ) {
      this.toast.sToast(
        "error",
        `Please select date range for ${this.tableOptions.downloadMax} days`
      );
      this.loaderService.display(false);
      return;
    }
    this.baseService
      .doRequest("/api/campaigndata/DownloadDevicedata", "post", params)
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result?.status === "ok") {
          console.log(result.msg);
          window.open(result.msg, "_blank");
          /*var a = document.createElement('a');
                a.href = result.msg;
                a.download = result.msg.substr(result.msg.lastIndexOf('/') + 1);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);*/
        } else {
          this.toast.sToast("error", result.msg);
        }
      });
  }

  columnFilter(val: any, col: any): void {
    this.searchedColName = col;
    this.colfilterUpdate.next({ value: val, col });
  }

  // removeFilter(filter: any): void {
  //   this.colFilters.forEach((obj: { key: string | number }, index: any) => {
  //     if (filter.key === obj.key) {
  //       this.colfilter[obj.key] = "";
  //       this.colHash[this.cFilter.selectedCol].val = "";
  //       this.cFilter.selectedCol = "";
  //       this.colFilters.splice(index, 1);
  //     }
  //   });
  //   this.colFilterCallback.emit({});
  //   this.colFilters =[];
  //   this.cFilter.selectedCol = '';
  //   this.commonService.clearFilterData.next('1')

  // }
  removeFilter(filter: any): void {
    const index = this.colFilters.findIndex((obj: { key: string | number }) => filter.key === obj.key);
    if (index >= 0) {
      const obj = this.colFilters[index];
      this.colfilter[obj.key] = "";
      if (this.colHash[this.cFilter.selectedCol] && this.colHash[this.cFilter.selectedCol].val) {
        this.colHash[this.cFilter.selectedCol].val = undefined;
      }
      if (this.cFilter.selectedCol != '') {
        this.colHash[this.cFilter.selectedCol].val = ""
      }
      this.cFilter.selectedCol = "";
      this.colFilters.splice(index, 1);
    }
    this.colFilterCallback.emit({});
    // this.commonService.clearFilterData.next('1');
  }
  getProperty(object: any, propertyName: any): any {
    let parts: any[] = [];
    let property: string;
    parts = propertyName.split(".");
    const length = parts.length;
    let i: number;
    property = object;
    for (i = 0; i < length; i++) {
      // @ts-ignore
      property = property[parts[i]];
    }
    return property;
  }

  rowClick(row: any, index: any): void {
    if (row._id) {
      this.dataSource.data.forEach((obj) => {
        obj.highlighted = obj._id === row._id;
      });
    } else {
      if (this.pastIndex !== undefined) {
        this.dataSource.data[this.pastIndex].highlighted = false;
      }
      this.pastIndex = index;
      this.dataSource.data[index].highlighted =
        !this.dataSource.data[index].highlighted;
    }
  }

  /*getProperty = (obj, path) => (
      path.split('.').reduce((o, p) => o && o[p], obj)
    )*/

  getCustomText(obj: any): any {
    // @ts-ignore
    const customText = this.sTableOptions.customText.filter(
      (x) => x?.status === obj
    );
    if (customText.length > 0) {
      return customText[0].DisplayText;
    }
  }

  // getCustomColor(obj) {
  //   const customText = this.sTableOptions.customText.filter(x => x?.status == obj);
  //   if (customText.length > 0) {
  //     return { 'background-color': customText[0].color };
  //   }
  //   return { 'background-color': '#ffffff' };
  // }

  getCustomColor(obj: any): any {
    const customText = this.sTableOptions.customText.filter(
      (x: any) => x?.status === obj
    );
    if (customText.length > 0) {
      return customText[0]["text-color"]
        ? {
          "background-color": customText[0].color,
          color: customText[0]["text-color"],
        }
        : { "background-color": customText[0].color };
    }
    return { "background-color": "#ffffff" };
  }

  getIconPath(obj: any, path: any): any {
    if (this.getProperty(obj, path.columnDef) === path.success) {
      return path.successIconPath !== undefined
        ? path.successIconPath
        : "assets/images/devices/online.svg";
    } else {
      return path.failureIconPath !== undefined
        ? path.failureIconPath
        : "assets/images/devices/offline.svg";
    }
  }

  getIconTooltip(obj: any, path: any): any {
    if (this.getProperty(obj, path.columnDef) === path.success) {
      return path.successToolTip !== undefined ? path.successToolTip : "Online";
    } else {
      return path.failureToolTip !== undefined
        ? path.failureToolTip
        : "Offline";
    }
  }

  drop(event: CdkDragDrop<string[]>): any {
    console.log('event', event);
    this.isActionChanged = true;
    moveItemInArray(
      this.showhideList,
      event.previousIndex,
      event.currentIndex
    );

    for (let idx = event.previousIndex; idx >= event.currentIndex; idx--) {
      this.showhideList[idx].order = idx;
    }
    // this.showhideList[event.previousIndex].order = event.previousIndex;
    // this.showhideList[event.currentIndex].order = event.currentIndex;
    this.initUpdateData();
  }

  actionCall(row: any, action: any): void {
    delete row.highlighted;
    delete row.hovered;
    const resp = { row, action };
    if (
      this.tableOptions.showAction &&
      this.tableOptions.actionMenuItems.length > 0
    ) {
      this.actionCallback.emit(resp);
    }
  }

  globalActionCall(row: any, action: any): void {
    delete row.highlighted;
    delete row.hovered;
    const resp = { row, action };
    if (
      this.tableOptions.showAction &&
      this.tableOptions.actionMenuItems.length > 0
    ) {
      this.globalActionCallback.emit(resp);
    }
  }

  hyperLinkCall(row: any, col?: any): any {
    delete row.highlighted;
    delete row.hovered;
    const event = { row, col };
    this.hyperlinkCallback.emit(event);
  }

  ngOnChanges(changes: SimpleChanges): any {
    const sTableOptions: SimpleChange = changes.sTableOptions;
    this._sTableOptions = sTableOptions.currentValue;
    // if (!sTableOptions.firstChange) {
    this.initUpdateData();
    // }
  }

  ngOnInit(): void {
    this.tmpOption = { ...this.sTableOptions };
    this.colHash = {};
    this.doFilter('');
    for (const c of this.tmpOption.columns) {
      this.columnsList.push(c.columnDef);
      this.colHash[c.columnDef] = c;
      if (c.colFilters && c.colFilters.hKey) {
        this.cFields.push(c.columnDef);
      }
    }
    this.cFilter = {
      selectedCol: ''
    };
  }

  ngOnDestroy(): void {
    this.isPageLoad = false;

    if (this.intervalId !== undefined && this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
    this.doFilter('');
  }

  initUpdateData(): void {
    this.tableOptions = Object.assign(
      this.tableOptions,
      this._sTableOptions.tableOptions
    );
    this.isPageLoad = this.sTableOptions.overridePageLoad
      ? false
      : this.isPageLoad;
    const filterK = localStorage.getItem(this.tableOptions.id);
    if (filterK && filterK !== "") {
      this.filterText = filterK;
      this.cdr.markForCheck();
      if (!this.called) {
        setTimeout(() => {
          localStorage.removeItem(this.tableOptions.id);
          this.doFilter(this.filterText);
          this.called = true;
        }, 2000);
      }
    }
    /*if (this.isPageLoad && !this.tableOptions.pageTotal ) {
          this.loaderService.display(true, 'Getting TableSettings data');
          const query = {query: {bool: {must: [ {exists: {field: 'tableId'}}, {exists: {field: 'columnRepr'}},
                {match: {'tableId.keyword': this.tableOptions.id}},
                  {match: {'userId.keyword': this.authenticationService.currentUser??.email}}]}}};
          const q = JSON.stringify(query);
          const skip = 0;
          const limit = 1;
          this.tableSettingsService.getAllApiTablesettingsGet({q, skip, limit}).subscribe((result: any) => {
              this.loaderService.display(false);
              if (result && result.data && result.data.length) {
                this.sessionData = result.data[0];
                try {
                  const savedCols = JSON.parse(result.data[0].columnRepr);
                  if (result.data[0].columnRepr && savedCols.length === this._sTableOptions.columns.length) {
                    this._sTableOptions.columns = savedCols;
                  }
                } catch (e) {
                  e = null;
                }
                this.selectedTimer = result.data[0].refreshInterval + '';
                this._sTableOptions.sortOptions.direction = (result.data[0].settings.sortOptions.direction === '')
                  ? 'asc' : result.data[0].settings.sortOptions.direction;
                this._sTableOptions.tableOptions.pageSize =  result.data[0].settings.pageSize;
                if (result.data[0].settings.pageSize !== this.tableOptions.pageSize) {
                  setTimeout(() => this.RefreshTableData(), 2000);
                }
                this.tableOptions.pageSize = result.data[0].settings.pageSize;
                this.setTableOptions(this._sTableOptions.tableOptions);
              }
          });
        } else {*/
    this.clearSelection();
    this.setTableOptions(this.tableOptions);
    this.cdr.markForCheck();
    /*}*/
    if (this.isPageLoad) {
      this.isPageLoad = false;
    }
  }

  setTableOptions(tblOptions: any): any {
    this.displayedColumns = [];
    this.orderlist = [];
    this.showhideList = this._sTableOptions.columns;
    // this.cdr.markForCheck();
    // this._sTableOptions.columns.map((c: any) => {
    //   if (c.visible) {
    //     this.displayedColumns.push(c.columnDef);
    //     this.orderlist.push(c);
    //   }
    // });
    this.dataSource.data = [];
    this._sTableOptions.columns.map((c: any) => {
      if (c.visible) {
        this.displayedColumns.push(c.columnDef);
        this.orderlist.push(c);
      }
    });
    this.cdr.markForCheck();
    if (tblOptions.compareData) {
      this.displayedColumns.push("compare");
    }

    if (tblOptions.showAction) {
      this.displayedColumns.push("action");
    }

    if (tblOptions.rowSelection) {
      this.displayedColumns.unshift("select");
    }

    // this.dataSource.data = this._sTableOptions.pageData;
    this.dataSource.data = this._sTableOptions.pageData;
    this.cdr.markForCheck();
    this.tableOptions.loading = false;
    /*if (this.sort) {
            this.dataSource.sort = this.sort;
        }*/

    // this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
    //     if (typeof data[sortHeaderId] === 'string') {
    //         return data[sortHeaderId].toLocaleLowerCase();
    //     }
    //     return data[sortHeaderId];
    // };

    if (!tblOptions.isServerSide) {
      this.dataSource.paginator = this.paginator;
    }
    this.filterArray = this.dataSource.filteredData;
  }

  // GetFinalColumns(savedColumns, definedColumns) {
  //   const finalcols = [];
  //   if (savedColumns.length >= definedColumns.length) {
  //     savedColumns.forEach(sCol => {
  //       try {
  //         for (let dCol = 0; dCol < definedColumns.length; dCol++) {
  //           if (sCol.columnDef == definedColumns[dCol].columnDef) {
  //             finalcols.push(sCol);
  //             break;
  //           }
  //           if (dCol == definedColumns.length - 1) {
  //             finalcols.push(definedColumns[dCol]);
  //           }
  //         }
  //       } catch (e) {
  //         e = null;
  //       }
  //     });
  //   } else if (definedColumns.length > savedColumns.length) {
  //     definedColumns.forEach(dCol => {
  //       for (let sCol = 0; sCol < savedColumns.length; sCol++) {
  //         try {
  //           if (dCol.columnDef == savedColumns[sCol].columnDef) {
  //             finalcols.push(savedColumns[sCol]);
  //             break;
  //           }
  //           if (sCol == savedColumns.length - 1) {
  //             finalcols.push(dCol);
  //           }
  //         } catch (e) {
  //           e = null;
  //         }
  //       }
  //     });
  //   }
  //   return finalcols;
  // }

  GetFinalColumns(savedColumns: any, definedColumns: any): any {
    // @ts-ignore
    definedColumns.forEach((obj) =>
      // @ts-ignore
      savedColumns.forEach((obj1) => {
        if (obj1.columnDef === obj.columnDef) {
          obj.visible = obj1.visible;
          obj.order = obj1.order;
        }
      })
    );
    try {
      // @ts-ignore
      definedColumns = definedColumns.sort((a, b) =>
        a.order > b.order ? 1 : -1
      );
    } catch (e) {
      e = null;
    }
    return definedColumns;
  }

  showHideColumn(i: any, val: any): void {
    val.visible = !val.visible;
    this.cdr.markForCheck();
    const index = this.orderlist.findIndex(
      (x) => x.columnDef === val.columnDef
    );
    if (index >= 0) {
      this.orderlist.splice(index, 1);
    } else {
      this.orderlist.push(val);
    }
    this.displayedColumns = [];
    this.orderlist = this.orderlist.sort((a, b) => a.order - b.order);

    if (this.tableOptions.compareData) {
      this.displayedColumns.push("compare");
    }

    if (this.tableOptions.rowSelection) {
      this.displayedColumns.push("select");
    }

    this.orderlist.forEach((element) => {
      this.displayedColumns.push(element.columnDef);
    });
    if (this.tableOptions.showAction) {
      this.displayedColumns.push("action");
    }
    this.isActionChanged = true;
    this.initUpdateData();
  }

  ngAfterViewInit(): void {
    this.isLoading = false;
    setTimeout(() => {
      this.initUpdateData();
    });
  }
  clearDaata(value) {
    this.cFilter.selectedCol = '';
    // this.commonService.clearFilterData.next(value)
  }
  pageChanged(event: any): void {
    this.isActionChanged = true;
    this.currentPageIndex = event.pageIndex;
    this.cpIndex = event.pageIndex;
    this.tableOptions.pageSize = event.pageSize;
    if (this.tableOptions.isServerSide) {
      this.pageCallback.emit(event);
    }
  }

  RefreshTableData(): void {
    this.refreshCallback.emit();
  }

  getCollectionData(): void {
    this.sTableOptions.dataList = [];
    this.loaderService.display(true, this.sTableOptions.lMsg);
    // tslint:disable-next-line:no-shadowed-variable
    let query: any = {};
    delete this.tmpOption.serverSide.q.query.bool.filter;
    this.tmpOption.serverSide.q.query.bool.must.forEach(
      (obj: any, index: number) => {
        if (obj.bool && obj.bool.should && obj.bool.should[0].match) {
          this.tmpOption.serverSide.q.query.bool.must.splice(index, 1);
        } else if (obj.multi_match) {
          this.tmpOption.serverSide.q.query.bool.must.splice(index, 1);
        }
      }
    );
    query = { ...this.tmpOption.serverSide.q };
    if (this.filterQuery && this.filterQuery.multi_match) {
      // Global filter
      query.query.bool.must.push(this.filterQuery);
    }
    if (this.colFilterQuery && this.colFilterQuery.length) {
      // Multi Column filter
      query.query.bool.filter = [];
      this.colFilterQuery.forEach((obj: any) => {
        if (obj.bool.should[0].match) {
          query.query.bool.must.push(obj);
        } else {
          query.query.bool.filter.push(obj);
        }
      });
    }
    const q = JSON.stringify(query);
    const skip = this.cpIndex;
    const limit = this.sTableOptions.pSize;
    const sort = JSON.stringify(this.sTableOptions.serverSide.sort);
    this.sTableOptions.loading = true; // @ts-ignore
    this.masterService[this.tOption.serverSide.service]
    [this.tmpOption.serverSide.fn]({ q, skip, limit, sort })
      .subscribe((result: any) => {
        this.sTableOptions.loading = false;
        this.loaderService.display(false);
        this.sTableOptions.dataList = result.data;
        this.sTableOptions.pTotal = result.total;
        this.initiateTable(result.data);
      });
  }

  initiateTable(dataList: any): void {
    const cols = dataList
      // tslint:disable-next-line:no-shadowed-variable
      .reduce((cols: any, row: {}) => [...cols, ...Object.keys(row)], [])
      // tslint:disable-next-line:no-shadowed-variable
      .reduce(
        (cols: string | any[], column: any) =>
          cols.includes(column) ? cols : [...cols, column],
        []
      );
    // Describe the columns for <mat-table>.
    /*this.columns = cols.map((column: string | number) => {
          return {
            columnDef: column,
            header: (this.colHash[column]) ? this.colHash[column].header : column,
            cell: (element: any) => `${element[column] ? element[column] : ``}`,
            ...this.colHash[column]
          };
        });*/
    this.displayedColumns = this.columnsList.slice();
    this.dataSource = new MatTableDataSource<any>(dataList);
    this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    this.totalCallback.emit({
      value: this.sTableOptions.pTotal,
      id: this.sTableOptions.id,
    });
  }

  openListColumns(): void {
    this.isExportClick = false;
    this.columnsCnt++;
    if (this.columnsCnt > 1) {
      this.columnsCnt = 1;
    }
  }

  timerCallData(): void {
    // this.listMenuTrigger.closeMenu();
    clearInterval(this.intervalId);
    this.intervalId = undefined;

    // if (this.selectedTimer !== undefined && Number(this.selectedTimer) !== 0) {
    //     clearInterval(this.intervalId);
    //     this.intervalId = setInterval(() => {
    //         this.timerCallback.emit(this.selectedTimer);
    //     }, Number(this.selectedTimer) * 1000);
    // }
  }

  filterDrpLstChange(data: any): void {
    // console.log(data);
    this.selectionchangeCallback.emit(data);
  }

  ParentCalls(id: any): void {
    this.parentCallback.emit(id);
  }

  AddTableRecord(): void {
    // this.listMenuTrigger.closeMenu();
    this.addCallback.emit();
  }

  publish(): void {
    this.publishCallback.emit();
  }

  CompareData(row: any): any {
    if (row.length <= 1) {
      this.toast.sToast("info", "Two files requires to compare");
      return false;
    }
    if (row.length > 2) {
      this.toast.sToast("info", "It not allow to compare more than 2 records");
      return false;
    }
    const resp = { row };
    this.compareCallback.emit(resp);
  }

  clearSelection(): void {
    this.selection.clear();
    // @ts-ignore
    this.numSelected = undefined;
  }

  clearCompCompareSelection(): void {
    this.compSelection.clear();
    // @ts-ignore
    this.compNumSelected = undefined;
  }

  isAllSelected(): any {
    this.numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (this.sTableOptions.tableOptions.isCheckboxSelection) {
      this.checkBoxCallback.emit(this.selection.selected);
    }
    return this.numSelected === numRows;
  }

  isAllCompSelected(): any {
    this.compNumSelected = this.compSelection.selected.length;
    const numRows = this.dataSource.data.length;
    return this.compNumSelected === numRows;
  }

  masterToggle(): void {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
    if (this.sTableOptions.tableOptions.isCheckboxSelection) {
      this.checkBoxCallback.emit(this.selection.selected);
    }
  }

  rowToggle(row: any): void {
    this.selection.toggle(row);
    if (this.sTableOptions.tableOptions.isCheckboxSelection) {
      this.checkBoxCallback.emit(this.selection.selected);
    }
  }

  masterCompToggle(): void {
    this.isAllCompSelected()
      ? this.compSelection.clear()
      : this.dataSource.data.forEach((row) => this.compSelection.select(row));
  }

  customSort(event: any): void {
    const filterData = this._sTableOptions.columns.filter((x) => x.columnDef === event.active);
    if (filterData && filterData[0] && filterData[0].searchstring) {
      event = {
        active: filterData[0].searchstring, direction: event.direction
      }
    }
    this._sTableOptions.sortOptions = event;
    if (this.tableOptions.isServerSide) {
      if (event.direction === "") {
        event.direction = this.sortOptions === "desc" ? "asc" : "desc";
      }
      this.sortCallback.emit(event);
    }
  }

  exportAllData(): void {
    const keymap = {};
    // @ts-ignore
    this._sTableOptions.columns.forEach((obj) => {
      // @ts-ignore
      keymap[obj.columnDef] = obj.header;
    });
    // @ts-ignore
    keymap._id = keymap._id ? keymap._id : "_id";
    this.loaderService.display(true);
    const name =
      this.tableOptions.title !== ""
        ? this.tableOptions.title.replace(/[^A-Z0-9]/gi, "_")
        : "Report";
    this.baseService
      .doRequest("/api/standardreports/generateReport", "post", {
        query: this._sTableOptions.query,
        keyMap: keymap,
        name,
      })
      .subscribe(
        (result: any) => {
          this.loaderService.display(false);
          if (result) {
            window.open(result.msg, "_blank");
          } else {
            this.toast.sToast("error", result.msg);
          }
        },
        () => {
          this.loaderService.display(false);
        }
      );
  }

  SaveSettings(): void {
    console.log('this._sTableOptions.tableOptions', this._sTableOptions.tableOptions);
    let item: any;
    item = {
      tableId: this._sTableOptions.tableOptions.id,
      userId: this.authenticationService.currentUser?.email,
      columnRepr: JSON.stringify(this._sTableOptions.columns),
      refreshInterval: +this.selectedTimer,
      settings: {
        filterText: this.filterText,
        gFilter: this._sTableOptions.gFilter ? this._sTableOptions.gFilter : [],
        sortOptions: this._sTableOptions.sortOptions,
        pageSize: this._sTableOptions.tableOptions.pageSize,
      },
    };
    item.settings.sortOptions.direction =
      this._sTableOptions.sortOptions.direction === ""
        ? "asc"
        : this._sTableOptions.sortOptions.direction;
    const method = this._sTableOptions.tableOptions && this._sTableOptions.tableOptions._id ? "put" : "post";
    const url = this._sTableOptions.tableOptions && this._sTableOptions.tableOptions._id ? `api/tables` : '/api/tables/table_settings_create'
    if (this._sTableOptions.tableOptions && this._sTableOptions.tableOptions._id) {
      item._id = this._sTableOptions.tableOptions._id;
    }
    console.log('item', item);
    console.log('url', url);
    console.log('method', method);

    this.baseService
      .doRequest(url, method, item)
      .subscribe((res: any) => {
        if (res && res._id && res.c !== null && res.u !== null) {
          this.toast.sToast("success", "Successfully updated!");
          setTimeout(() => {
            this.authenticationService.getTableDetails(this.commonService.userEmail);
          }, 2000);
        } else {
          this.toast.sToast("error", res._id);
        }
      });

    /*const method = this.tableId ? 'put' : 'post';
        const url = this.tableId ? `/api/user_settings/${this.tableId}` : `/api/user_settings`;
        this.baseService.doRequest(url, method, {
          tablename: this.tableOptions.id.toLowerCase(),
          // @ts-ignore
          username: this.authenticationService.currentUser._id,
          userdata: JSON.stringify(_settings)
        }).subscribe((result: any) => {
          if (result) {
            this.sessionData = [];
            this.toast.sToast('success', 'Settings updated');
            this.sessionData = JSON.parse(result.msg[0].userdata);
          } else {
            this.toast.sToast('error', result.msg);
          }
        });*/
  }

  doFilter = (value: string) => {
    // this.isActionChanged = true;
    localStorage.setItem(this.tableOptions.id, value);
    if (this.tableOptions.isServerSide) {
      this.filterCallback.emit(value);
    } else {
      this.dataSource.filter = value.trim().toLocaleLowerCase();
      this.dataSource.data = this._sTableOptions.pageData.filter((row: any) =>
        JSON.stringify(row).toLowerCase().includes(value.trim().toLocaleLowerCase())
      );
    }
  };
  doColumFilter = (value: string, col: string): any => {
    if (this.tableOptions.isServerSide) {
      // @ts-ignore
      if (this.colFilters.filter((x) => x.key === col).length > 0) {
        // @ts-ignore
        this.colFilters.forEach((obj, index) => {
          if (col === obj.key && value === "") {
            this.colFilters.splice(index, 1);
            this.colListFilterCallback.next(this.colFilters);
          } else {
            obj.value = value;
          }
        });
      } else {
        if (value === "") {
          return false;
        }
        const colName = this._sTableOptions.columns.filter(
          (x: any) => x.columnDef === col
        )[0].header;
        this.colFilters.push({ key: col, name: colName, value });
        this.colListFilterCallback.next(this.colFilters);
      }
      this.colFilterCallback.emit({ value, col });
    } else {
      this.filterValues = value.toLowerCase();
      this.dataSource.data = this.filterArray.filter((row: any) =>
        row[this.searchedColName].toLowerCase().includes(this.filterValues)
      );
    }
  };
}
